import React, { useEffect, useState } from 'react';
import { Fade } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Table from './../../Components/Table';

function FirstStep({ firstStep, menu, moto, codpmpol, motoQuotes, vehicleData }) {
  const [nomsec, setNomsec] = useState('');
  const navigate = useNavigate();
  const marca = moto.motoBrand.find(brand => brand.value === firstStep.brand)?.label;
  const modelo = moto.motoModel.find(model => model.value === firstStep.model)?.label;

  useEffect(() => {
    setNomsec(menu.find(item => item.codsec === firstStep.codsec)?.nomsec)
    codpmpol === "" && navigate("/");
  }, []);

  return (
    <Fade appear in>
      <div className="qs qsmargin"> 
        <div className="tableFirst">
          <div className='d-flex flex-column justify-content-start m-0 scroll-off'>
            <div>
              <div className='d-flex flex-column m-0 mx-1 mb-3 scroll-off'>
                <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>Cotización {nomsec}</h1>
                <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
              </div>
              <div className=''>
                {
                  firstStep.type === "moto" &&
                  <>
                    <h2 className='text-start fs-6 ms-1'>{marca} {modelo}</h2>
                    <h2 className='text-start fs-6 ms-1'>Suma asegurada ${motoQuotes[0]?.suma}</h2>
                  </>
                }
              </div>
              <Table />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

function mapStateToProps(state) {
  return {
    firstStep: state.mainReducer.firstStep,
    vehicleData: state.mainReducer.vehicleData,
    menu: state.mainReducer.menu,
    moto: state.mainReducer.moto,
    codpmpol: state.mainReducer.codpmpol,
    motoQuotes: state.mainReducer.motoQuotes,
  }
};

export default connect(mapStateToProps)(FirstStep);
